import { Stack, StackProps, styled } from "@mui/material";

export const FiltersAndLayersContainer = styled((props: StackProps) => <Stack spacing={1} {...props} />)(
  ({ theme }) => ({
    height: "100%",
    overflowX: "hidden",
    overflowY: "auto",
  }),
);
